import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getData, postData } from './api'
import { OverdueNextActionDatesState } from './typings'
import { StoreData } from '@user/store/reducers/typings'
import { updateAssigneeIdsNullValue } from '@user/components/Dashboard/widgets/utils/updateAssigneeIdsNullValue'

export const initialState: OverdueNextActionDatesState = {
  assigneeId: null,
  assigneeIds: [],
  data: {
    leadsOverdue: 0,
    leadsOverdueValue: 0,
    opportunitiesOverdue: 0,
    opportunitiesValue: 0,
    salesTeamId: null,
    salesTeamIds: [],
    salesTeamName: null,
    salesTeamNames: null,
    assigneeId: null,
    assigneeIds: [],
    assigneeName: null,
    assigneeNames: null,
    branches: null,
  },
  isLoading: false,
  salesTeamId: null,
  salesTeamIds: [],
  showFront: true,
}

const overdueNextActionDatesSlice = createSlice({
  name: 'dashboard/overdueNextActionDates',
  initialState: initialState,
  reducers: {
    flipCard: (state: OverdueNextActionDatesState) => {
      state.showFront = !state.showFront
    },
    setSalesTeamId: (state, { payload }: PayloadAction<number | null>) => {
      state.salesTeamId = payload
    },
    setSalesTeamsIds: (state, { payload }: PayloadAction<number[]>) => {
      state.salesTeamIds = payload
    },
    setAssigneeId: (state, { payload }: PayloadAction<string | null>) => {
      state.assigneeId = payload
    },
    setAssigneeIds: (state, { payload }: PayloadAction<string[]>) => {
      state.assigneeIds = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, { payload }) => {
      payload.assigneeIds = updateAssigneeIdsNullValue(payload.assigneeIds)
      state.data = payload
      state.assigneeId = payload.assigneeId
      state.assigneeIds = payload.assigneeIds
      state.salesTeamId = payload.salesTeamId
      state.salesTeamIds = payload.salesTeamIds
    })
    builder.addCase(postData.fulfilled, (state, { payload }) => {
      state.assigneeId = payload.assigneeId
      state.salesTeamId = payload.salesTeamId
    })
  },
})

export const selectOverdueNextActionDates = (state: StoreData) => {
  return state.dashboard.overdueNextActionDates
}

export const {
  flipCard,
  setAssigneeId,
  setSalesTeamId,
  setSalesTeamsIds,
  setAssigneeIds,
} = overdueNextActionDatesSlice.actions
export const reducer = overdueNextActionDatesSlice.reducer
